var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeposit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.446 7.38a.85.85 0 00-1.178 1.226l5.144 4.942a.85.85 0 001.178 0l5.144-4.942a.85.85 0 00-1.178-1.226l-3.705 3.56V3.05a.85.85 0 10-1.7 0v7.889L5.446 7.38zM4 16.203a.85.85 0 000 1.7h12.002a.85.85 0 100-1.7H4z",
    fill: "currentColor"
  })));
}
export default SvgDeposit;